module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'search') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("设置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "钉在顶部"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.fixTop),
      callback: function($$v) {
        _vm.$set(_vm.config, "fixTop", $$v)
      },
      expression: "config.fixTop"
    }
  })], 1), _vm._v(" "), (!_vm.config.fixTop) ? _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启扫码"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.scanCode),
      callback: function($$v) {
        _vm.$set(_vm.config, "scanCode", $$v)
      },
      expression: "config.scanCode"
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41fc7da7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41fc7da7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/search.vue
// module id = 2665
// module chunks = 0